<template>
  <div id="navigation">
    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <div
          class="main-toolbar"
          :class="{ change_color: scrollPosition > 50 }"
        >
          <md-toolbar class="md-transparent">
            <div class="md-toolbar-row" style="margin-top: 0px;">
              <div
                class="md-toolbar-section-start"
                :class="{ change_color: scrollPosition > 50 }"
              >
                <a v-if="mobilescreen" href="/">
                  <img
                    src="img/rpas_logo.png"
                    style="max-width: 60%;"
                    class="center"
                  />
                </a>
                <a v-else href="/" style="width: 200px">
                  <img
                    src="img/rpas_logo.png"
                    style="max-width: 80%;"
                    class="center"
                  />
                </a>
                <div class="md-collapse">
                  <md-list>
                    <li class="md-list-item">
                      <div class="md-list-item-content">
                        <router-link to="/">
                          <md-button class="md-simple md-primary">{{
                            $t("Home")
                          }}</md-button>
                        </router-link>
                      </div>
                    </li>
                    <li class="md-list-item md-expand">
                      <div class="md-list-item-content">
                        <drop-down direction="down">
                          <md-button
                            slot="title"
                            class="md-simple md-primary dropdown-toggle"
                            data-toggle="dropdown"
                          >
                            {{ $t("Pilot Network") }}
                          </md-button>
                          <ul class="dropdown-menu dropdown-with-icons">
                            <li class="md-simple md-primary">
                              <a href="#/flight-review/map">
                                <span class="material-icons">
                                  tour
                                </span>
                                <p>{{ $t("Flight Review") }}</p>
                              </a>
                            </li>
                          </ul>
                        </drop-down>
                      </div>
                    </li>
                    <li class="md-list-item md-expand">
                      <div class="md-list-item-content">
                        <drop-down direction="down">
                          <md-button
                            slot="title"
                            class="md-simple md-primary dropdown-toggle"
                            data-toggle="dropdown"
                          >
                            {{ $t("Product") }}
                          </md-button>
                          <ul class="dropdown-menu dropdown-with-icons">
                            <li class="md-simple md-primary">
                              <a href="#/product">
                                <i class="material-icons">developer_board</i>
                                <p>{{ $t("Features") }}</p>
                              </a>
                            </li>
                            <!-- <li class="md-simple md-primary">
                              <a
                                href="https://docs.rpaswilco.com"
                                target="_blank"
                              >
                                <i class="material-icons">library_books</i>
                                <p>{{ $t("User Manual") }}</p>
                              </a>
                            </li> -->
                          </ul>
                        </drop-down>
                      </div>
                    </li>
                    <li class="md-list-item">
                      <div class="md-list-item-content">
                        <router-link to="pricing">
                          <md-button class="md-simple md-primary">{{
                            $t("Pricing")
                          }}</md-button>
                        </router-link>
                      </div>
                    </li>
                    <li class="md-list-item">
                      <div class="md-list-item-content">
                        <router-link to="ContactUs">
                          <md-button class="md-simple md-primary">{{
                            $t("Contact Us")
                          }}</md-button>
                        </router-link>
                      </div>
                    </li>
                    <li class="md-list-item">
                      <div class="md-list-item-content">
                        <md-button
                          class="md-simple md-primary"
                          @click="signup"
                          >{{ $t("Sign Up") }}</md-button
                        >
                      </div>
                    </li>
                    <li class="md-list-item">
                      <div class="md-list-item-content">
                        <md-button
                          class="md-simple md-primary"
                          @click="login"
                          >{{ $t("Log In") }}</md-button
                        >
                      </div>
                    </li>
                    <li class="md-list-item">
                      <div class="md-list-item-content">
                        <md-button
                          class="md-simple md-primary"
                          @click="switchLanguage"
                          >{{ language }}</md-button
                        >
                      </div>
                    </li>
                  </md-list>
                </div>
              </div>
              <div
                class="md-toolbar-section-end"
                :class="{ change_color: scrollPosition > 50 }"
                style="justify-content: center;"
              >
                <div class="hamburger">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-button-link md-simple dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <i class="material-icons">reorder</i>
                    </md-button>
                    <ul class="dropdown-menu dropdown-with-icons">
                      <li>
                        <a href="#/">
                          <i class="material-icons">home</i>
                          <p>{{ $t("Home") }}</p>
                        </a>
                      </li>
                      <li>
                        <a href="#/flight-review/map">
                          <span class="material-icons">
                            tour
                          </span>
                          <p>{{ $t("Flight Review") }}</p>
                        </a>
                      </li>
                      <li>
                        <a href="#/product">
                          <i class="material-icons">developer_board</i>
                          <p>{{ $t("Features") }}</p>
                        </a>
                      </li>
                      <li>
                        <a href="#/pricing">
                          <i class="material-icons">payments</i>
                          <p>{{ $t("Pricing") }}</p>
                        </a>
                      </li>
                      <!-- <li>
                        <a href="https://docs.rpaswilco.com" target="_blank">
                          <i class="material-icons">library_books</i>
                          <p>{{ $t("User Manual") }}</p>
                        </a>
                      </li> -->
                      <li>
                        <a href="#/ContactUs">
                          <i class="material-icons">contact_support</i>
                          <p>{{ $t("Contact Us") }}</p>
                        </a>
                      </li>
                      <li>
                        <a @click="signup">
                          <i class="material-icons">create</i>
                          <p>{{ $t("Sign Up") }}</p>
                        </a>
                      </li>
                      <li>
                        <a @click="login">
                          <i class="material-icons">login</i>
                          <p>{{ $t("Log In") }}</p>
                        </a>
                      </li>
                      <li>
                        <a @click="switchLanguage">
                          <i class="material-icons">login</i>
                          <p>{{ language }}</p>
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </div>
            </div>
          </md-toolbar>
        </div>
      </div>
    </div>

    <modal v-if="showLogin">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeLogin"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <login></login>
      </template>
    </modal>

    <modal v-if="showSignup">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeSignup"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <register></register>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";
import { EventBus } from "@/helpers";
import Login from "@/pages/Landing/Login.vue";
import Register from "@/pages/Landing/Register.vue";
import swal from "sweetalert2";

export default {
  props: {
    logoImg: {
      type: String,
      default: "./img/wilcoapplogo.png"
    }
  },
  components: {
    Modal,
    Login,
    Register
  },
  data() {
    return {
      language: window.localStorage.getItem("locale") === "fr" ? "EN" : "FR",
      showLogin: false,
      showSignup: false,
      scrollPosition: null,
      responsive: false,
      toggleCard: false,
      mobilescreen: false
    };
  },
  methods: {
    switchLanguage() {
      var locale = this.language.toLowerCase();
      window.localStorage.setItem("locale", locale);
      this.$root.$i18n.locale = locale;
      this.language = this.language === "FR" ? "EN" : "FR";
    },
    login() {
      this.$router.push("/login");
    },
    closeLogin() {
      this.showLogin = false;
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    signup() {
      this.$router.push("/signup");
    },
    closeSignup() {
      this.showSignup = false;
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    toggle() {
      this.toggleCard = !this.toggleCard;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 800) {
        this.mobilescreen = true;
      } else {
        this.mobilescreen = false;
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("scroll", this.updateScroll);
    EventBus.$on("signedup", () => {
      this.showSignup = false;
      swal.fire({
        title: this.$t("Thank You"),
        text: this.$t(
          "You successfully signed up. Please check your email to activate your account!"
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.addEventListener("resize", this.onResponsiveInverted);
    EventBus.$off("signedup");
  }
};
</script>

<style lang="css">
#navigation {
  .md-button .md-button-content {
    color: #005fb2;
    font-size: 16px;
    font-weight: 600;
  }
  .md-list-item-content {
    padding: 4px 0;
  }
  .dropdown-toggle .md-ripple:after,
  .dropdown .dropdown-menu .dropdown-toggle:after {
    color: #005fb2;
  }
}
.main-toolbar {
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  .md-toolbar {
    backdrop-filter: blur(4px);
  }
}
.md-toolbar {
  background-color: rgba(0, 0, 0, 0.5);
}
.change_color {
  background-color: white;
}
@media all and (min-width: 991px) {
  .hamburger {
    display: none;
  }
}
@media all and (max-width: 768px) {
  .main-toolbar {
    background-color: white;
  }
}
</style>
